import React from "react";
import moment from "moment";
import TaskContainer from "../../../Components/DragAndDrop/TaskContainer";
import { useSelector } from "react-redux";
export default function Day({ date }) {
  const tasks = useSelector((state) =>
    state.tasks.filter(
      (t) => !t.complete && moment(t.date).isSame(moment(date), "date")
    )
  );
  const isInPast = moment().isAfter(moment(date));
  const isToday = moment().isSame(moment(date), "date");
  const getColor = () => {
    const isOdd = moment(date).month() % 2 == 1;
    if (isToday) {
      return "#d9e7ff";
    } else if (isInPast) {
      return isOdd ? "#333" : "#777";
    } else {
      return isOdd ? "#ccc" : "#eee";
    }
    return "#333";
    //   !thisMonth
    //       ? "#333"
    //       : isToday
    //       ? "#d9e7ff"
    //       : isInPast
    //       ? "#aaa"
    //       : "white",
  };
  return (
    <div
      style={{
        flexGrow: 1,
        width: `${100 / 7}%`,
        backgroundColor: getColor(),
        border: "1px solid white",
        display: "flex",
        flexFlow: "column",
      }}
    >
      <TaskContainer
        tasks={tasks}
        id={moment(date).format("L")}
        canCreate={true}
        label={moment(date).date()}
        labelColor={!isInPast || isToday ? "black" : "white"}
      />
    </div>
  );
}
